<template>
  <res-dialog 
    :showDialog="showDialog"
    :maxWidth="maxWidth"
    :setWidth="setWidth"
    setHeight="300"
    saveButtonColor="resBlue darken-1"
    cancelButtonColor="resBlue darken-1"
    title=""
    titleClass="resBlue darken-1 white--text"
    :showTitleIcon="false"
    :titleIconSize="17"
    iconColor="white"
    saveButtonText="CREATE"
    :saveDisabled="!canCreate"
    cancelButtonText="CANCEL"
    cancelButtonWidth="80"
    :defaultButtonAction="confirm"
    @save="confirm"
    @cancel="cancel" >
    <v-card-text>
      <res-dialog :showDialog="showHelp"
                  titleClass="resBlue darken-1 white--text"
                  iconColor="white"
                  cancelButtonText="Close"
                  :cancelButtonOnly="true"
                  cancelButtonColor="resBlue darken-1"
                  :maxWidth="800"
                  :setWidth="800"
                  :setHeight="600"
                  @cancel="closeHelp">
        <reforecast-help :openSection="openHelpSection"></reforecast-help>
      </res-dialog>
      <div class="help-controls" @click="openHelp(null)">
        <span class="help-label">Help</span>
        <v-icon color="var(--v-resBlue-darken1)" class="pb-1" small>mdi-help-circle</v-icon>
      </div>
      <div class="py-5">
        I would like to create a Reforecast budget that has current year actuals for all GL Account through
        <div class="short">
          <res-select :id="'reforecast-month-selector'" v-model="throughMonthOption" :items="throughMonthOptions" :attach="'#reforecast-month-selector'" placeholder="select month"></res-select>
        </div>
      </div>
      <v-divider></v-divider>
      <div class="py-5">
        And, for the remaining months, I would like them populated with <div class="short medium">
          <res-select :id="'reforecast-populate-selector'" v-model="populateWithOption" :items="populateWithOptions" :attach="'#reforecast-populate-selector'"></res-select>
        </div>
      </div>
      <v-divider></v-divider>
      <div class="py-5">
        I would like to Deactivate the Market Rent and Occupancy worksheets and only enter my changes on GL Accounts <div class="short shorter">
          <res-select :id="'reforecast-deactivate-selector'" v-model="deactivateMarketRentAndOccupancy" :items="deactivateMarketRentAndOccupancyOptions" :attach="'#reforecast-deactivate-selector'"></res-select>
        </div>
      </div>
    </v-card-text>
  </res-dialog>
</template>

<script>
  import ResDialog from '@/components/base/ResDialog.vue';
  import ResSelect from '@/components/base/ResSelect.vue';

  import ReforecastHelp from '@/components/help/ReforecastHelp.vue';
  import HelpableMixin from '@/mixins/Helpable.js';

  import { mapGetters, mapActions } from 'vuex';

  export default {
    components: {
      ReforecastHelp,
      ResDialog,
      ResSelect
    },
    mixins: [HelpableMixin],
    props: {
      showDialog: {
        type: Boolean
      },
      maxWidth: {
        type: Number
      },
      setWidth: {
        type: Number
      },
      budgetYear: {
        type: Number
      },
      budgetStartMonth: {
        type: Number
      }
    },
    data: function () {
      return {
        throughMonthOption: 0,
        populateWithOption: 1,
        deactivateMarketRentAndOccupancy: 1
      }
    },
    computed: {
      ...mapGetters(['currentLoading']),
      throughMonthOptions() {
        return this.getMonthOptions(this.budgetYear, true, this.budgetStartMonth)
      },
      populateWithOptions() {
        return [
          {
            text: 'Budget Numbers',
            value: 1
          },
          {
            text: 'Zeros',
            value: 2
          }
        ]
      },
      deactivateMarketRentAndOccupancyOptions() {
        return [{ text: 'YES', value: 1 }, { text: 'NO', value: 0 }];
      },
      canCreate() {
        return !this.currentLoading && Boolean(this.throughMonthOption);
      }
    },
    methods: {
      ...mapActions(['changeLoading']),
      getMonthOptions(year, includeYear, startMonth) {
        startMonth = startMonth - 1 || 0; // startMonth is used as an index
        let priorYear = includeYear ? year - 1 : '';
        if (priorYear > 0 || !includeYear) {
          var months = [
            { text: 'January ', value: 1 },
            { text: 'February ', value: 2 },
            { text: 'March ', value: 3 },
            { text: 'April ', value: 4 },
            { text: 'May ', value: 5 },
            { text: 'June ', value: 6 },
            { text: 'July ', value: 7 },
            { text: 'August ', value: 8 },
            { text: 'September ', value: 9 },
            { text: 'October ', value: 10 },
            { text: 'November ', value: 11 },
            { text: 'December ', value: 12 }
          ];
          var returnMonths = [];
          for (var i = startMonth; i < startMonth + 12; i++) {
            var monthYear = startMonth == 0 ? year : i < 12 && i > 0 ? priorYear : i < 24 ? year : year + 1;
            var thisMonth = months[i % 12];
            thisMonth.text += monthYear;
            returnMonths.push(thisMonth)
          }
          return returnMonths;
        }
        return []
      },
      cancel() {
        this.$emit('cancel', true)
      },
      confirm() {
        this.changeLoading(true);
        this.$emit('confirm', { throughMonthOption: this.throughMonthOption, populateWithOption: this.populateWithOption, deactivateMarketRentAndOccupancy: this.deactivateMarketRentAndOccupancy });
      }
    }
  }
</script>

<style scoped lang="scss">
  .short {
    max-width: 150px;
    display: inline-block;
    margin-left: 10px;
    max-height:30px;
  }
  .short.shorter {
    max-width: 90px;
  }
  .short.medium {
    max-width: 220px;
  }

  .v-input#reforecast-month-selector::v-deep {
    div.menuable__content__active {
      max-height: 215px !important;
    }
  }
</style>
